import apiClient from './api';

/** Island geography reference data (apps/geo): read-only, the same on every tenant. */
export const geoService = {
  /** Every active town / village / quarter, district first then A to Z, each
   *  with the district it is filed under — the branch form's Locality picker
   *  holds this list and filters it as the user types. */
  localitiesAll: async () => {
    const { data } = await apiClient.get('/geo/localities/all');
    return data?.results || [];
  },
};
